import { useEffect } from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';
import { getTokens } from '../../common/services/security/userAuthService';
import authorizationService from '../../common/services/security/authorizationService';
import locationService from '../../common/services/locationService';

const landingPath = '../';

const Access = () => {
  const location = useLocation();
  const { code: accessCode, state } = qs.parse(location.search);

  let redirect = landingPath;
  if (state) {
    try {
      const decoded = atob(state);
      if (decoded.match(/^\//)) {
        redirect = decoded;
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  useEffect(() => {
    if (accessCode) {
      getTokens(accessCode)
        .then((tokenSet) => {
          authorizationService.setTokens(tokenSet);
          locationService.redirect(redirect);
        })
        .catch(() => {
          locationService.redirect(landingPath);
        });
    }
  }, [accessCode, redirect]);
  return null;
};

export default Access;
